export const ORGANIZATION_FUNCTIONS = [
  { id: 0, name: 'バイタル入力機能' },
  { id: 1, name: 'お薬情報' },
  { id: 10, name: 'ビデオ通話発信' },
  { id: 11, name: 'オンライン診療' }
]
